// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 21"
    {...props}
  >
    <path
      fill="#fff"
      stroke="#9FA5AB"
      d="M10.561 0.849183C10.7505 0.501713 11.2495 0.501713 11.439 0.849183L14.0721 5.6773C14.2878 6.0729 14.67 6.35054 15.1129 6.43348L20.5184 7.44575C20.9074 7.5186 21.0616 7.9931 20.7896 8.2807L17.0115 12.2769C16.7019 12.6043 16.556 13.0536 16.614 13.5004L17.3216 18.9542C17.3726 19.3467 16.9689 19.6399 16.6114 19.4702L11.6432 17.1119C11.2362 16.9186 10.7638 16.9186 10.3568 17.1119L5.38863 19.4702C5.03108 19.6399 4.62744 19.3467 4.67837 18.9542L5.38604 13.5004C5.44402 13.0536 5.29806 12.6043 4.98849 12.2769L1.21035 8.2807C0.938447 7.9931 1.09262 7.5186 1.48165 7.44575L6.88714 6.43348C7.33004 6.35054 7.71219 6.0729 7.92793 5.6773L10.561 0.849183Z"
    />
  </svg>
);
const IconEmptyStar = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconEmptyStar;
